<app-headerfr></app-headerfr>
<section class="patinet_support" id="patient_support_fr">
    <div class="content-container">
      <div class="pure-g">
        <div class="pure-u-1">
            <div class="content">
              <h2>
                Soutien aux patients
              </h2>
              <p>
                Une expérience harmonieuse, de l’inscription au traitement, avec un soutien continu et une coordination des soins avec votre équipe de soins de santé.
              </p>
              <h3>
                CE QUE VOUS POUVEZ ATTENDRE DE NOTRE PROGRAMME :
              </h3>
            </div>
            <div class="image">
              <img src="/assets/img/patient_program.png" alt="Patient Program" class="mobilehidden" />
              <div class="text-links-desktop mobilehidden">
                <div class="enrollment">
                  <div class="text-wrapper">
                    <div class="link"><a (click)="showpopup('enrollment')">Inscription</a></div>
                    <app-patient-support *ngIf="enrollment" [messageh3]="enrollmenth3" [messagep]="enrollmentp"
                      [path]="enrollmentpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
                  </div>
                </div>
                <div class="supplies">
                  <div class="text-wrapper">
                    <div class="link"><a (click)="showpopup('orderingsupplies')">Commander des<br/>fournitures</a></div>
                    <app-patient-support *ngIf="orderingsupplies" [messageh3]="ordersuupliesh3" [messagep]="ordersuupliesp"
                      [path]="ordersuupliespath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
                  </div>
                </div>
                <div class="coordination">
                  <div class="text-wrapper">
                    <div class="link"><a (click)="showpopup('productcoordination')">Coordination du<br/> produit</a></div>
                    <app-patient-support *ngIf="productcoordination" [messageh3]="productcoorh3" [messagep]="productcoorp"
                      [path]="productcoorpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
                  </div>
                </div>
                <div class="training">
                  <div class="text-wrapper">
                    <div class="link"><a (click)="showpopup('trainingsupport')">Formation et<br/> soutien</a></div>
                    <app-patient-support *ngIf="trainingsupport" [messageh3]="trainingsuph3" [messagep]="trainingsupp"
                      [path]="trainingsuppath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
                  </div>
                </div>
                <div class="reports">
                  <div class="text-wrapper">
                    <div class="link"><a (click)="showpopup('reportstophysician')">Rapports au médecin et à <br/>l’équipe de soins de santé</a></div>
                    <app-patient-support *ngIf="reportstophysician" [messageh3]="physicianh3" [messagep]="physicianp"
                      [path]="physicianpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
                  </div>
                </div>
              </div>
    
              <div class="desktophidden text-links-mobile">
                <app-patient-support *ngIf="enrollment" [messageh3]="enrollmenth3" [messagep]="enrollmentp"
                  [path]="enrollmentpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
                <app-patient-support *ngIf="orderingsupplies" [messageh3]="ordersuupliesh3" [messagep]="ordersuupliesp"
                  [path]="ordersuupliespath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
                <app-patient-support *ngIf="productcoordination" [messageh3]="productcoorh3" [messagep]="productcoorp"
                  [path]="productcoorpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
                <app-patient-support *ngIf="trainingsupport" [messageh3]="trainingsuph3" [messagep]="trainingsupp"
                  [path]="trainingsuppath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
                <app-patient-support *ngIf="reportstophysician" [messageh3]="physicianh3" [messagep]="physicianp"
                  [path]="physicianpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
                <div class="pure-g">
                  <div class="pure-u-md-5-24 pure-u-1-24"></div>
                  <div class="pure-u-md-7-24 pure-u-11-24 text-wrapper-mobile">
                    <img src="/assets/img/patient_program_mob_bg.png" alt="Patient Program" />
                    <p><a (click)="showpopup('enrollment')">Inscription</a></p>
                  </div>
                  <div class="pure-u-md-7-24 pure-u-11-24 text-wrapper-mobile">
                    <img src="/assets/img/patient_program_mob_bg.png" alt="Patient Program" />
                    <p><a (click)="showpopup('orderingsupplies')">Commander des<br/> fournitures</a></p>
                  </div>
                  <div class="pure-u-md-5-24 pure-u-1-24"></div>
                  <div class="pure-u-md-5-24 pure-u-1-24"></div>
                  <div class="pure-u-md-7-24 pure-u-11-24 text-wrapper-mobile">
                    <img src="/assets/img/patient_program_mob_bg.png" alt="Patient Program" />
                    <p><a (click)="showpopup('productcoordination')">Coordination du <br/>produit</a></p>
                  </div>
                  <div class="pure-u-md-7-24 pure-u-11-24 text-wrapper-mobile">
                    <img src="/assets/img/patient_program_mob_bg.png" alt="Patient Program" />
                    <p><a (click)="showpopup('trainingsupport')">Formation et<br/>soutien</a></p>
                  </div>
                  <div class="pure-u-md-5-24 pure-u-1-24"></div>
                  <div class="pure-u-1 text-wrapper-mobile">
                    <img src="/assets/img/patient_program_mob_bg.png" alt="Patient Program" />
                    <p><a (click)="showpopup('reportstophysician')">Rapports au médecin et à <br/>l’équipe de soins de santé</a></p>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="enrol-wrapper">
              <a href="#">
                <div class="enrol-section">
                  <div class="text">
                    Pour vous inscrire, veuillez consulter votre professionnel de la santé.
                  </div>
                </div>
              </a>
            <div class="content-section">
              <p>
                Êtes-vous un professionnel de la santé?<br>
                 <span>Visitez la plateforme CSL Behring pour les professionnels de la santé pour télécharger un formulaire d’inscription. </span>  
              </p>
              <a class="btn" href="https://hcp.cslbehring.ca/fr-fr/" title="Visitez dès maintenant" target ="_blank">
                Visitez dès maintenant
               </a> 
            </div>
            </div>
        </div>
      </div>
    </div>
  </section>
  <section id="sec_cslnews">
    <div class="csl_news">

        <div class="content-container">
            <h2>Nouveautés : Portail de commande <br />de fournitures CSL PLUS</h2>
            <!-- <div class="border">
                <p></p>
            </div> -->
            <div class="pure-g content_wrap">
                <div class="pure-u-md-6-24 pure-u-xl-3-24"></div>
                <div class="pure-u-md-12-24 pure-u-xl-18-24">
                    <p>Il est maintenant plus facile de commander des fournitures et d’accéder à des renseignements utiles grâce au nouveau <strong>portail Web de commande en libre-service</strong> pour nos patients et nos professionnels de la santé*. C’est simple, rapide et sécuritaire. En seulement quelques clics, vous pouvez :</p>
                </div>
                <div class="pure-u-md-6-24 pure-u-xl-3-24"></div>
            </div>
            <div class="pure-g">
                <div class="newcsl_wrapper">
                    <div class="pure-u-1 pure-u-md-7-24">
                        <div class="section">
                            <div class="image">
                                <img src="/assets/img/anchillary-suplies.svg" />
                            </div>
                            <div class="content">
                                <p>Dès votre inscription, commander <strong>sans frais</strong> des <strong>fournitures auxiliaires</strong> pour votre traitement.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="pure-u-1 pure-u-md-1-24"></div>
                    <div class="pure-u-1 pure-u-md-7-24 margin_top">
                        <div class="section">
                            <div class="image">
                                <img src="/assets/img/insightful-digital.svg" />
                            </div>
                            <div class="content">
                                <p>Accéder à <strong>des ressources numériques et imprimées pertinentes</strong> pour vous soutenir pendant votre traitement.</p>
                            </div>
                        </div>
                    </div>
                    <div class="pure-u-1 pure-u-md-1-24"></div>
                    <div class="pure-u-1 pure-u-md-7-24 margin_top">
                        <div class="section">
                            <div class="image">
                                <img src="/assets/img/support-caller.svg" />
                            </div>
                            <div class="content">
                                <p>Profiter d’une expérience personnalisée avec <strong>accès et assistance en tout temps</strong>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1 button_wrapper">
                    <a href="https://cslbehringplus.rxdirect.ca/fr/" class="btn" title="ACCÉDER AU PORTAIL DE COMMANDE" target="_blank">ACCÉDER AU PORTAIL DE COMMANDE </a>
                </div>
                <div class="footnote">
                    <p>* Ce portail de commande a pour but d’obtenir des fournitures auxiliaires pour la formation des patients auxquels sont prescrits des produits CSL Behring. En utilisant ce portail, vous acceptez de commander les fournitures nécessaires uniquement pour les patients auxquels sont prescrits des produits CSL Behring.</p>
                </div>
            </div>

        </div>

    </div>
    <div class="bg_gray">
        <div class="radius_border"></div>
    </div>
</section>
  <section class="healthcare_professional_support" id="HCPs_fr">
    <div class="content-container">
      <div class="pure-g">
        <div class="pure-u-1">
         <div class="title">
          <h2>
            Soutien pour les professionnels de la santé
          </h2>
          <h3>
            CSL BEHRING S’ENGAGE À SOUTENIR LES PROFESSIONNELS DE LA SANTÉ DANS LA PRESTATION DE SOINS AUX PATIENTS
          </h3>
         </div>
        </div>
      </div>
    </div>
      <div class="enrolment-form-wrapper">
        <div class="hcp-support-col">
          <div class="hcp-support-image">
            <img src="/assets/img/HCP_support.png" alt="HCP support Image" class="" />
          </div>
          <div class="gray-bg">
            <div class="content">
              <div class="image pure-u-1 pure-u-md-8-24">
                <img src="/assets/img/form_icon.svg" alt="Form Icon" class="" />
              </div>
              <div class="text pure-u-1 pure-u-md-13-24">
                <h3>
                  LA PLATEFORME CSL BEHRING POUR LES PROFESSIONNELS DE LA SANTÉ
                </h3>
                <p>
                  Votre <strong>source unique</strong> de ressources pour les produits CSL Behring, y compris des renseignements sur les produits, des outils pour les patients et du matériel de soutien.
                </p>
                <p>
                  Vous pouvez également inscrire vos patients au <strong>programme de soutien aux patients CSL Plus<sup>&trade;</sup></strong>, conçu pour faciliter le parcours de traitement d’un patient.
                </p>
                <p>
                  <a href="https://hcp.cslbehring.ca/fr-fr/" title="Cliquez ici pour vous connecter et télécharger un formulaire d’inscription" target ="_blank">Cliquez ici pour vous connecter et télécharger un formulaire d’inscription</a>
                </p>
              </div>
              <div class="pure-u-1 pure-u-md-3-24"></div>
            </div>
          </div>
        </div>
        <div class="content-container-zero">
          <div class="pure-g">
            <div class="pure-u-1">
  
            </div>
          </div>
        </div>
      </div>
  </section>
  <section class="contact" id="contact_us_fr">
    <div class="content-container">
      <div class="pure-g">
        <div class="pure-u-1 centered">
          <h2>
            Vous avez des questions? Nous sommes là pour vous aider.
          </h2>
          <p>
            SI VOUS AVEZ DES QUESTIONS, CONTACTEZ LE PROGRAMME DE SOUTIEN AUX PATIENTS CSL PLUS :
          </p>
        </div>
      </div>
      <div class="pure-g col">
          <div class="pure-u-1 pure-u-md-6-24">
            <div>
              <img src="/assets/img/contact_icon.svg" alt="PAR COURRIEL " class="" />
              <h3>PAR COURRIEL : </h3>
            </div>
            <div class="text">
              <p>
                <a href="mailto:support@cslplus.ca" title="support@cslplus.ca">support&#64;cslplus.ca</a>
              </p>
            </div>
          </div>
          <div class="pure-u-1 pure-u-md-3-24"></div>
          <div class="pure-u-1 pure-u-md-6-24">
            <div>
              <img src="/assets/img/contact_icon.svg" alt="PAR TÉLÉPHONE" class="" />
              <h3>PAR TÉLÉPHONE : </h3>
            </div>
            <div class="text">
              <p>
                <a href="tel:18884904105" title="tel:18884904105">1-888-490-4105</a>
                <br/> 
                du lundi au vendredi,<br/>
                de 8 h à 16 h (HE)              
              </p>
              
            </div>
          </div>
          <div class="pure-u-1 pure-u-md-3-24"></div>
          <div class="pure-u-1 pure-u-md-6-24">
            <div>
              <img src="/assets/img/contact_icon.svg" alt="NUMÉRO POUR" class="" />
              <h3>NUMÉRO POUR LES DEMANDES URGENTES EN DEHORS DES HEURES NORMALES :</h3>
            </div>
            <div class="text">
              <p>
                <a href="tel:(514) 219-7560" title="tel:(514) 219-7560">(514) 219-7560</a>
              </p>
            </div>
          </div> 
      </div>
    </div>
  </section>
<app-footerfr></app-footerfr>